import "./TakeawayPaymentModal.scss";

import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getAds, createPayment } from "../../../../utility";
import { setEmail } from "../../../../redux/cart/reducer";
import ENV from "../../../../env";
import Input from "../../../../components/Input";
import TakeawayCareModal from "../takewayCareModal/TakeawayCareModal";
import { Modal } from "react-bootstrap";
import GradientButton from "../../../../components/buttons/gradientButton/GradientButton";
import OutlinedPinkButton from "../../../../components/buttons/outlinedPinkButton/OutlinedPinkButton";
import { hasEnoughStockForCart } from "../../../../utility/stockManagement";

function TakeawayPaymentModal({ setOpen, open, sellerPaysFees }) {
  const [careModalOpen, setCareModalOpen] = useState(false);
  const [careModalMessage, setCareModalMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [email, setEmailValue] = useState("");
  const [note, setNote] = useState("");
  const [ad, setAd] = useState();
  const { t } = useTranslation("takeaway");

  const { orgId } = useParams();
  const cartStore = useSelector((state) => state.cartReducer.cartByOrg[orgId] || []);
  const savedEmail = useSelector((state) => state.cartReducer.email);
  const dispatch = useDispatch();

  let total = 0;
  let fee = 0;

  cartStore?.forEach((i) => {
    total += parseFloat(i?.totalDue || 0);
  });
  fee = parseFloat(total * 0.03);
  fee += 0.35;

  const fetchAdvertisement = async () => {
    const fetchedAd = await getAds("bannerAd");
    setAd(fetchedAd.ad);
  };

  useEffect(() => {
    if (savedEmail) {
      setEmailValue(savedEmail);
    }
    fetchAdvertisement();
  }, [savedEmail]);

  const handleEmailChange = (e) => {
    setEmailValue(e.target.value);
  };

  const handlePayment = async () => {
    const emailPattern = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;

    if (!email.match(emailPattern)) {
      setCareModalMessage(t("error_email_invalid"));
      setCareModalOpen(true);
      return;
    }
    if (!hasEnoughStockForCart(cartStore)) {
      setCareModalMessage(t("maxQuantityReached"));
      setCareModalOpen(true);
      return;
    }

    try {
      setCareModalMessage(t("redirecting_to_payment"));
      setCareModalOpen(true);

      setLoading(true);
      dispatch(setEmail(email));
      await createPayment({
        amount: total,
        products: cartStore,
        customerEmail: email,
        customerNote: note,
        orgId: orgId,
        checkoutUrl: `${ENV.hostname}/takeaway/${orgId}`,
        isTakeaway: true,
        note: note,
        sellerPaysFees: sellerPaysFees,
      });
      setCareModalMessage(t("redirect_success"));
    } catch (err) {
      setCareModalMessage(t("payment_error"));
      setCareModalOpen(true);
      console.error("Failed to save the participant:", err);
    }
    setLoading(false);
  };

  return (
    <>
      <Modal onHide={setOpen} show={open} centered className="takeaway-payment-modal">
        <Modal.Body className="cashless-payment-modal-body">
          <div className="header-section">
            <div className="title">{t("payment_title")}</div>
          </div>

          <div className="content-section">
            <div className="price-area">
              <div className="price-area-totalCart">
                <h2 className="price-area-totalCart-title">{t("total_cart")} :</h2>
                <h2 className="price-area-totalCart-amount">{total.toFixed(2)}€</h2>
              </div>
              {!sellerPaysFees && (
                <>
                  <div className="price-area-fees">
                    <h2 className="price-area-fees-title-fee">{t("application_fee")} :</h2>
                    <h2 className="price-area-fees-amount-fee">
                      {(0.35 + 0.03 * total).toFixed(2)}€
                    </h2>
                  </div>
                  <div className="price-area-fees">
                    <h2 className="price-area-fees-title">{t("total")} :</h2>
                    <h2 className="price-area-fees-amount">
                      {(Number((0.35 + 0.03 * total).toFixed(2)) + Number(total)).toFixed(2)}€
                    </h2>
                  </div>
                </>
              )}
            </div>
            <div className="email-area">
              <Input
                placeholder="johndoe@mail.com"
                label="Email pour le reçu"
                onChange={handleEmailChange}
                value={email}
              />
            </div>
            <div className="note-area">
              <label className="form-label __form-label">
                {t("note_label")} {`(${note.length}/100)`}
              </label>
              <textarea
                className="form-control __form-control"
                onChange={(e) => {
                  if (e.target.value.length <= 100) {
                    setNote(e.target.value);
                  }
                }}
                value={note}
              />
            </div>
          </div>

          <div className="footer-section">
            <div className="subtext">{t("secure_payment")}</div>
            <div className="buttons-container">
              <GradientButton onPress={handlePayment}>
                {loading ? t("loading") : t("pay_button")}
              </GradientButton>
              <OutlinedPinkButton onPressFunction={() => setOpen(false)}>
                {" "}
                {t("cancel")}{" "}
              </OutlinedPinkButton>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <TakeawayCareModal
        open={careModalOpen}
        setOpen={setCareModalOpen}
        message={careModalMessage}
      />
    </>
  );
}

export default TakeawayPaymentModal;
